; (function ($, Object, Array, undefined) {
    router = resultsRouter;

    var KeywordFilterManager = function (searchBox) {
        this.searchBox = searchBox;
    };

    KeywordFilterManager.prototype = {
        updateUi: function () {
            this.searchBox.val(this.value);
        },
        getSearchTerms: function () {
            var searchTerms = this.searchBox.val();
            searchTerms = searchTerms.replace("‘", "'");
            searchTerms = searchTerms.replace("’", "'");

            if (searchTerms !== "" && searchTerms !== "Keywords") {
                this.value = searchTerms;
            }
            else {
                this.value = "";
            }
        },
        setSearchTerms: function (searchTerms) {
            if (Array.isArray(searchTerms)) {
                this.value = searchTerms.length ? searchTerms[0] : "";
            }
            else {
                this.value = searchTerms;
            }
            this.updateUi();
        },
        removeSearchTerm: function (breadcrumb) {
            var breadcrumbValue = breadcrumb.children(".text").text(),
                index = this.value.indexOf(breadcrumbValue);

            this.value = "";
            this.updateUi();
        }
    };

    var PracticeFilterManager = function (dropdown) {
        this.dropdown = dropdown;
        this.resultsMap = new Map();
    };

    PracticeFilterManager.prototype = {
        updateUi: function () {
            this.dropdown.val("");
            this.dropdown.prev().text(this.dropdown.children("[value='']").text());
        },
        setPractices: function (practices) {
            if (practices.length !== 0 && !this.isUUID(...practices)) {
                practices.forEach(x => this.addValueToMap(x, this.getDropdownByText(this.dropdown.find('option'), x).val()));
                this.value = this.resultsMap;
            }
            else {
                this.value = practices;
            }

            this.updateUi();
        },
        addPractice: function (practiceName, practiceGuid) {
            if (!this.resultsMap.has(practiceName)) {
                this.resultsMap.set(practiceName, practiceGuid);
            }

            this.value = this.resultsMap;
            this.updateUi();
        },
        removePractice: function (breadcrumb) {
            var breadcrumbValue = breadcrumb.children(".text").text();

            this.value.delete(breadcrumbValue);
            this.updateUi();
        },
        isUUID: function (uuid) {
            let s = "" + uuid;
            s = s.match('^[0-9a-fA-F]{32}$');

            return s === null ? false : true;
        },
        addValueToMap: function (dropdownValue, dropdownGuid) {
            if (!this.resultsMap.has(dropdownValue)) {
                this.resultsMap.set(dropdownValue, dropdownGuid);
            }
        },
        getDropdownByText: function (selector, value) {
            return $(selector).filter(function () { return $(this).text() == value });
        }
    };

    var DropdownFilterManager = function (dropdown, isType) {
        this.dropdown = dropdown;
        this.isType = isType;
    };

    DropdownFilterManager.prototype = {
        updateUi: function (value) {
            this.dropdown.val("");
            let textElement = this.dropdown.prev();
            if (this.isType)
                textElement = textElement.prev();
            if (value && value.length > 0 && this.isType)
                textElement.text(value);
            else
                textElement.text(this.dropdown.children("[value='']").text());
        },
        setValues: function (values) {
            this.value = values;
            this.updateUi(values);
        },
        addValue: function (value) {
            if (this.value.indexOf(value) < 0) {
                this.value.push(value);
            }
            this.updateUi();
        },
        removeValue: function (breadcrumb) {
            var breadcrumbValue = breadcrumb.children(".text").text(),
                index = this.value.indexOf(breadcrumbValue);

            this.value.splice(index, 1);
            this.updateUi();
        }
    };

    var BreadcrumbManager = function (breadcrumbContainer) {
        this.breadcrumbContainer = breadcrumbContainer;
    };

    BreadcrumbManager.prototype = {
        updateBreadcrumbs: function (filterType, values) {
            var typeContainer = this.breadcrumbContainer.children("[data-type='" + filterType + "']"),
                breadcrumbs = typeContainer.children(),
                bound = breadcrumbs.length,
                i;

            //remove empty elements from values 
            values = values.filter(Boolean);

            if (values.length < bound) {
                bound = values.length;

                for (i = breadcrumbs.length - 1; i >= bound; i--) {
                    breadcrumbs.eq(i).remove();
                }
            }
            else if (values.length > bound) {
                var additional = values.slice(bound - values.length);

                for (i = 0; i < additional.length; i++) {
                    if (additional[i] !== "") {
                        typeContainer.append("<button class='search-criteria-item'><span class='text'>" + additional[i] + "</span><i class='fa fa-plus-circle'></i></button>");
                    }
                }
            }

            for (i = 0; i < bound; i++) {
                if (values[i] !== "") {
                    breadcrumbs.eq(i).children(".text").text(values[i]);
                }
            }

            if (this.getBreadcrumbs().length > 0) {
                this.breadcrumbContainer.css("visibility", "visible");
            }
            else {
                this.breadcrumbContainer.css("visibility", "hidden");
            }
        },
        getBreadcrumbs: function () {
            return this.breadcrumbContainer.find(".search-criteria-item");
        },
        clearAll: function () {
            this.getBreadcrumbs().remove();
            this.breadcrumbContainer.css("visibility", "hidden");
        }
    };

    var FilterManager = function () {
        this.bm = new BreadcrumbManager($(".search-criteria-breadcrumbs"));
        this.kfm = new KeywordFilterManager($(".search-box input[type='text']"));
        this.ifm = new PracticeFilterManager($(".filter-dropdown.industry select"));
        this.pfm = new PracticeFilterManager($(".filter-dropdown.practice select"));
        this.tfm = new DropdownFilterManager($(".select-dropdown.types select"), true);
        this.page = 0;
    };

    FilterManager.prototype = {
        init: function (url, callback, filters) {
            // init manager
            this.url = url;
            this.callback = callback;
            this.bindEvents();

            // init keywords
            this.kfm.setSearchTerms(filters.keywords);
            this.bm.updateBreadcrumbs("keyword", [this.kfm.value]);

            // init industries
            this.ifm.setPractices(filters.industries);
            this.bm.updateBreadcrumbs("industry", this.ifm.value);

            // init practices
            this.pfm.setPractices(filters.practices);
            this.bm.updateBreadcrumbs("practice", this.pfm.value);

            // init types
            this.tfm.setValues(filters.type);
            this.bm.updateBreadcrumbs("type", [this.tfm.value]);
        },
        handlePopstate: function (filters) {
            this.page = filters.page;

            // init keywords
            this.kfm.setSearchTerms(filters.keywords);
            this.bm.updateBreadcrumbs("keyword", [this.kfm.value]);

            // init industries
            this.ifm.setPractices(filters.industries);
            this.bm.updateBreadcrumbs("industry", Array.from(this.ifm.value.keys()));

            // init practices
            this.pfm.setPractices(filters.practices);
            this.bm.updateBreadcrumbs("practice", Array.from(this.pfm.value.keys()));

            // init types
            this.tfm.setValues(filters.type);
            this.bm.updateBreadcrumbs("type", [this.tfm.value]);

            this.getFilteredResults(false);

            console.log('popstate triggered search:');
            console.log(filters);
        },
        reset: function () {
            this.page = -1;
        },
        getState: function (loadAllUpToPage) {
            this.page++;

            if (this.kfm.value == "Keywords")
                this.kfm.value = null;
            return {
                keywords: this.kfm.value,
                industries: Array.from(this.ifm.value.values()),
                practices: Array.from(this.pfm.value.values()),
                type: this.tfm.value,
                page: this.page,
                loadAllUpToPage: loadAllUpToPage,
            };
        },
        readState: function () {
            return {
                keywords: this.kfm.value,
                industries: Array.from(this.ifm.value.keys()),
                practices: Array.from(this.pfm.value.keys()),
                type: this.tfm.value,
                page: this.page,
            };
        },
        clearAll: function () {
            this.bm.clearAll();
            this.kfm.setSearchTerms("");
            this.ifm.resultsMap.clear();
            this.pfm.resultsMap.clear();
            this.tfm.setValues('');
            this.reset();
            this.getFilteredResults();
        },
        clearAllNoSearch: function () {
            this.bm.clearAll();
            this.kfm.setSearchTerms("");
            this.ifm.resultsMap.clear();
            this.pfm.resultsMap.clear();
            this.tfm.setValues('');
            this.reset();
        },
        handleSearch: function () {
            this.kfm.getSearchTerms();
            this.bm.updateBreadcrumbs("keyword", [this.kfm.value]);
            this.reset();
            this.getFilteredResults();
        },
        getFilteredResults: function (isProgrammatic) {
            if (!isProgrammatic) {
                router.state = this.readState();
                router.push();
            }

            $.ajax({
                type: "POST",
                url: this.url,
                data: JSON.stringify(this.getState(isProgrammatic)),
                contentType: "application/json",
                success: this.callback
            });
        },
        bindEvents: function () {
            var _this = this;

            $(".search-box button").on("click", function () {
                var keyword = $(".search-box input[type='text']").val();
                if (keyword != "" && keyword != "Keywords") {
                    _this.clearAllNoSearch();
                    $(".search-box input[type='text']").val(keyword);
                    _this.handleSearch();
                }
            });

            _this.kfm.searchBox.on("keydown", function (e) {
                if (e.which === 13) {
                    var keyword = $(".search-box input[type='text']").val();
                    if (keyword != "" && keyword != "Keywords") {
                        _this.clearAllNoSearch();
                        $(".search-box input[type='text']").val(keyword);
                        _this.handleSearch();
                    }

                    return false;
                }
            });

            _this.ifm.dropdown.on("change", function () {
                _this.ifm.addPractice($(this).children(":selected").text(), $(this).children(":selected").val());
                _this.bm.updateBreadcrumbs("industry", Array.from(_this.ifm.value.keys()));
                _this.reset();
                _this.getFilteredResults();
            });

            _this.pfm.dropdown.on("change", function () {
                _this.pfm.addPractice($(this).children(":selected").text(), $(this).children(":selected").val());
                _this.bm.updateBreadcrumbs("practice", Array.from(_this.pfm.value.keys()));
                _this.reset();
                _this.getFilteredResults();
            });

            _this.tfm.dropdown.on("change", function () {
                _this.tfm.setValues($(this).children(":selected").text());
                _this.bm.updateBreadcrumbs("type", [_this.tfm.value]);
                _this.reset();
                _this.getFilteredResults();
            });

            _this.bm.breadcrumbContainer.on("click", ".search-criteria-item", function () {
                if (_this.bm.getBreadcrumbs().length === 1) {
                    _this.clearAll();
                }
                else {
                    var filterType = $(this).parent().attr("data-type");

                    switch (filterType) {
                        case "keyword":
                            _this.kfm.removeSearchTerm($(this));
                            break;
                        case "industry":
                            _this.ifm.removePractice($(this));
                            break;
                        case "practice":
                            _this.pfm.removePractice($(this));
                            break;
                        case "type":
                            _this.tfm.setValues('');
                            break;
                    }

                    $(this).remove();
                    _this.reset();
                    _this.getFilteredResults();
                }
            });

            _this.bm.breadcrumbContainer.on("click", ".btn-clear", function () {
                _this.clearAll();
            });
        }
    };

    $.extend({
        filterManager: new FilterManager()
    });

    router.init();

})(jQuery, Object, Array);